import FailureSummaries from '../../../modules/failure-summaries/containers/failure-summaries';

export default {
  path: ':organization/events/failures/summaries',
  title: 'Event Failure Summaries',
  indexRoute: {
    component: FailureSummaries,
  },
};
